module.exports = __webpack_public_path__ + "media/images/article/2022_01_a-27b8f21c47f58835b4720303cafa5884.png";